<template>
  <div>
    <div class="my-container" style="box-shadow: 0 0 5px 1px #C0C0C0;">
      <h1>choose analysis:</h1>
      <div class="RadioBox" style="text-align: left">
        <el-radio-group v-model="choose_method" size="mini" @change="changeDownloadCode">
          <span class="fontClass">Gene Level Analysis:</span>
          <el-radio :label="1" class="RadioItem1" border><span style="font-size: 18px">Marker</span></el-radio>
          <el-radio :label="2" class="RadioItem1" border><span style="font-size: 18px">SVGs</span></el-radio>
          <br/>
          <span class="fontClass">Celltype Level Analysis:</span>
          <el-radio :label="3" class="RadioItem1" border><span style="font-size: 18px">Cell Type Annotation</span></el-radio>
          <br/>
          <span class="fontClass">Cancer Level Analysis:</span>
          <el-radio :label="4" class="RadioItem1" border><span style="font-size: 18px">Tumor malignancy estimation</span></el-radio>
          <el-radio :label="5" class="RadioItem1" border><span style="font-size: 18px">Cancer function states evaluation</span></el-radio>
          <br/>
          <span class="fontClass"></span>
          <el-radio :label="6" class="RadioItem1" border><span style="font-size: 18px">Immune component characterization</span></el-radio>
          <el-radio :label="7" class="RadioItem1" border><span style="font-size: 18px">TLS Analysis</span></el-radio>
          <el-radio :label="8" class="RadioItem1" border><span style="font-size: 18px">Custom gene Analysis</span></el-radio>
        </el-radio-group>
      </div>

      <br/>
      <br/>


      <h1>Choose dataset:</h1>
      <span style="font-size: 20px">Use your dataset:&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <el-radio-group v-model="choose_dataset">
        <el-radio :label="true"><span style="font-size: 20px">True</span></el-radio>
        <el-radio :label="false"><span style="font-size: 20px">False</span></el-radio>
      </el-radio-group>
      <div>
        <template v-if="choose_dataset">
          <el-upload
              class="upload-demo"
              drag
              action="https://jsonplaceholder.typicode.com/posts/">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text" style="font-size: 18px">Drag file here，or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip" style="font-size: 18px">Only seurat object, upload rds file, no more than 30MB</div>
          </el-upload>
          <!--          <div style="width: 50%">-->
          <!--            <el-input placeholder="please choose file" v-model="dataset_textarea" size="mini">-->
          <!--              <el-button-->
          <!--                  slot="append"-->
          <!--                  icon="el-icon-folder-opened"-->
          <!--                  @click="openFile"-->
          <!--              ></el-button>-->
          <!--            </el-input>-->
          <!--            <input-->
          <!--                type="file"-->
          <!--                name="filename"-->
          <!--                id="open"-->
          <!--                style="display: none"-->
          <!--            />-->
          <!--          </div>-->
        </template>
        <template v-else>
          <span>Cancer Type:</span>
          <el-select v-model="chooseCancer" placeholder="choose Cancer Type" clearable @change="selectCancer" size="mini">
            <el-option
                v-for="item in datasetName"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dataset:</span>
          <el-select v-model="chooseDataset" placeholder="choose Dataset" clearable @change="selectDataset" size="mini">
            <el-option
                v-for="item in dataset_result_list"
                :key="item.datasetID + '---' + item.name"
                :label="item.datasetname + '---' + item.name"
                :value="item.datasetID + '---' + item.name">
            </el-option>
          </el-select>
        </template>
      </div>

<!--      <h1>upload gene list:</h1>-->
<!--      <div>-->
<!--        <el-upload-->
<!--            class="upload-demo"-->
<!--            drag-->
<!--            action="https://jsonplaceholder.typicode.com/posts/">-->
<!--          <i class="el-icon-upload"></i>-->
<!--          <div class="el-upload__text">drag file here，or <em>click to upload</em></div>-->
<!--          <div class="el-upload__tip" slot="tip">only gene list, upload csv/txt file, no more than 10MB</div>-->
<!--        </el-upload>-->
<!--      </div>-->
      <br/>
      <el-button @click="submitFile" style="font-size: 18px">Submit</el-button>

      <p v-show="show_download_code" style="font-size: 20px">download code <a :href="download_code_url" class="my-a" target="_blank">here</a></p>
    </div>


  </div>
</template>

<script>
export default {
  name: "CalDataset",
  data() {
    return {
      choose_method: '',
      choose_dataset: true,
      dataset_textarea: '',
      datasetName: ['Breast Cancer', 'PDAC', 'SCC', 'Melanoma', 'Prostate Cancer', 'Liver Cancer', 'Ovarian Cancer', 'Glioblastoma',
        'Colorectal Cancer', 'Cervical Cancer', 'Bladder Cancer', 'Brain metastases', 'Lung Cancer', 'Head and neck Cancer'],
      chooseCancer: '',
      dataset_result_list: [],
      chooseDataset: '',
      file_name_list: ['Marker.R', 'SVGs.R', 'CellTypeAnnotation.R', 'TumorMalignancyEstimation.R', 'CancerFunctionStatesEvaluation.R', 'ImmuneComponentCharacterization.R', 'TLSAnalysis.R'],
      show_download_code: false,
      download_code_url: '',
    }
  },
  methods: {
    openFile () {
      new Promise((resolve) => {
        document.getElementById("open").click()
        resolve();
      }).then(() => {this.changeFile()})
    },
    changeFile() {
      const fu = document.getElementById("open");
      if (fu == null) return;
      console.log(fu)
      this.dataset_textarea = fu.files[0].name;
    },
    selectCancer(){
      let _this = this
      // console.log(_this.chooseCancer)
      _this.chooseDataset = ''
      _this.$axios.get(
          'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/datasets/' + _this.chooseCancer)
          .then(function (response) {
            // console.log(temp)
            _this.dataset_result_list = response.data
            // console.log(_this.dataset_result_list)
          })
    },
    selectDataset(){
      console.log(this.chooseDataset)
    },
    submitFile(){},
    changeDownloadCode(){
      let _this = this
      if (_this.choose_method !== ''){
        _this.show_download_code = true
        _this.download_code_url = 'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/file/download/script/' + _this.file_name_list[_this.choose_method - 1]
      }else {
        _this.show_download_code = false
      }

    },
  }
}
</script>

<style scoped>
.fontClass{
  color: black;
  font-size:18px;
  width: 200px;
  margin-left: 30px;
  display: inline-block;
}

.RadioBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /*padding: 20px;*/
  margin: 10px auto;
}

.RadioItem1 {
  /*display: flex;*/
  width: 350px;
  margin: 0 10px 10px 0;
  font-size: 18px;
  /*align-items: center;*/
}
</style>
